module.exports = "\n<div class=\"wrapper\">\n  <app-navbar></app-navbar>\n  <app-sidemenu></app-sidemenu>\n  <div class=\"content\">\n  \t<router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tutor-panel/tutor-panel.component.html
// module id = ./src/app/tutor-panel/tutor-panel.component.html
// module chunks = main